// import React, { useEffect, useMemo, useState } from "react";
// import { Box, Card, CardContent, Stack, Typography, Button, Tabs, Tab, Snackbar, Alert, CircularProgress } from "@mui/material";
// import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
// import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
// import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

// import ApiServices from "../../../../Utils/ApiServices/ApiServices";
// import { getDecryptedAccessToken } from "../../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

// import EmailTemplatesTab from "./components/EmailTemplatesTab";
// import EmailLogsTab from "./components/EmailLogsTab";
// import EmailSmtpTab from "./components/EmailSmtpTab";
// import EmailTemplateDialog from "./components/EmailTemplateDialog";
// import SendEmailDialog from "./components/SendEmailDialog";

// const BASE_URL = "/api/v1";

// export const TEMPLATE_TYPES = [
//   "DISCOUNT_CAMPAIGN",
//   "ANNOUNCEMENT",
//   "FESTIVAL_OFFER",
//   "LOYALTY_REWARD",
//   "ORDER_CONFIRMATION",
//   "REENGAGEMENT",
//   "CUSTOM",
// ];

// export const TEMPLATE_STATUS = ["draft", "active", "archived"];

// export const defaultTemplateForm = (clientId) => ({
//   id: null,
//   name: "",
//   template_type: "CUSTOM",
//   is_global: false,
//   client_id: clientId || "",
//   subject: "",
//   preview_text: "",
//   body_json: {
//     blocks: [
//       { type: "header", content: "Your Email Title" },
//       { type: "text", content: "Hi {{name}}, your message goes here." },
//       { type: "button", label: "Call To Action", url: "{{action_url}}" },
//       { type: "footer", content: "Rite Clinic" },
//       { type: "unsubscribe", text: "Unsubscribe" },
//     ],
//   },
//   body_html: "",
//   variables: [],
//   thumbnail_url: "",
//   status: "draft",
// });

// export const defaultSendForm = {
//   template_id: "",
//   recipient_email: "",
//   variablesText: '{\n  "name": "Priya",\n  "action_url": "https://example.com"\n}',
//   campaign_id: "",
//   unsubscribe_url: "",
//   reply_to: "",
// };

// export const defaultSmtpForm = {
//   smtp_host: "",
//   smtp_port: 587,
//   smtp_user: "",
//   smtp_password: "",
//   use_tls: true,
//   use_ssl: false,
//   from_email: "",
//   is_active: true,
// };

// export const extractVariablesFromTemplate = (form) => {
//   const found = new Set();

//   const scan = (value) => {
//     if (!value || typeof value !== "string") return;
//     const matches = value.match(/\{\{(.*?)\}\}/g) || [];
//     matches.forEach((m) => {
//       const cleaned = m.replaceAll("{", "").replaceAll("}", "").trim();
//       if (cleaned) found.add(cleaned);
//     });
//   };

//   scan(form.subject);
//   scan(form.preview_text);
//   scan(form.body_html);

//   (form?.body_json?.blocks || []).forEach((block) => {
//     Object.values(block || {}).forEach((val) => {
//       if (typeof val === "string") scan(val);
//     });
//   });

//   return Array.from(found);
// };

// export const buildBodyHtmlFromBlocks = (blocks = []) => {
//   const htmlParts = blocks.map((block) => {
//     switch (block.type) {
//       case "header":
//         return `<h1 style="font-family:Arial,sans-serif;margin:0 0 16px;">${block.content || ""}</h1>`;
//       case "text":
//         return `<p style="font-family:Arial,sans-serif;font-size:14px;line-height:1.7;margin:0 0 14px;">${block.content || ""}</p>`;
//       case "image":
//         return block.url
//           ? `<img src="${block.url}" alt="${block.alt || ""}" style="max-width:100%;border-radius:8px;margin:0 0 16px;" />`
//           : "";
//       case "button":
//         return `<p style="margin:18px 0;"><a href="${block.url || "#"}" style="display:inline-block;background:#1976d2;color:#fff;text-decoration:none;padding:12px 18px;border-radius:6px;font-family:Arial,sans-serif;">${block.label || "Click"}</a></p>`;
//       case "footer":
//         return `<hr style="border:none;border-top:1px solid #ddd;margin:24px 0 12px;" /><p style="font-family:Arial,sans-serif;font-size:12px;color:#666;">${block.content || ""}</p>`;
//       case "unsubscribe":
//         return `<p style="font-family:Arial,sans-serif;font-size:12px;color:#666;text-decoration:underline;">${block.text || "Unsubscribe"}</p>`;
//       default:
//         return "";
//     }
//   });

//   return `<html><body style="margin:0;padding:24px;background:#f7f7f7;"><div style="max-width:680px;margin:0 auto;background:#ffffff;border:1px solid #e5e7eb;border-radius:12px;padding:24px;">${htmlParts.join("")}</div></body></html>`;
// };

// const ClientEmailManager = () => {
//   const clientId = sessionStorage.getItem("activeClientId");
//   const token = getDecryptedAccessToken();

//   const [tab, setTab] = useState(0);
//   const [loading, setLoading] = useState(false);

//   const [templates, setTemplates] = useState([]);
//   const [logs, setLogs] = useState([]);
//   const [smtpConfig, setSmtpConfig] = useState(null);

//   const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
//   const [sendDialogOpen, setSendDialogOpen] = useState(false);
//   const [smtpDialogOpen, setSmtpDialogOpen] = useState(false);

//   const [templateForm, setTemplateForm] = useState(defaultTemplateForm(clientId));
//   const [sendForm, setSendForm] = useState(defaultSendForm);
//   const [smtpForm, setSmtpForm] = useState(defaultSmtpForm);

//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [templateFilter, setTemplateFilter] = useState({
//     search: "",
//     type: "",
//     status: "",
//   });

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const authHeaders = useMemo(
//     () => ({
//       Authorization: `Bearer ${token}`,
//       "Content-Type": "application/json",
//     }),
//     [token]
//   );

//   const showSnackbar = (message, severity = "success") => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const handleApiError = (error, fallback = "Something went wrong") => {
//     const msg =
//       error?.response?.data?.detail ||
//       error?.response?.data?.non_field_errors?.[0] ||
//       error?.response?.data?.message ||
//       fallback;

//     if (error?.response?.status === 423) {
//       showSnackbar(
//         msg || "Email templates module is not enabled for this client.",
//         "warning"
//       );
//       return;
//     }

//     showSnackbar(msg, "error");
//   };

//   const fetchTemplates = async () => {
//     if (!clientId) {
//       showSnackbar("Client ID not found in sessionStorage.", "error");
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await ApiServices.get(
//         `${BASE_URL}/email-templates/?client_id=${clientId}`,
//         authHeaders
//       );
//       setTemplates(Array.isArray(response?.data) ? response.data : []);
//     } catch (error) {
//       handleApiError(error, "Failed to fetch templates");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchLogs = async () => {
//     try {
//       setLoading(true);
//       const response = await ApiServices.get(
//         `${BASE_URL}/email-templates/logs/?client_id=${clientId}`,
//         authHeaders
//       );
//       setLogs(Array.isArray(response?.data) ? response.data : []);
//     } catch (error) {
//       handleApiError(error, "Failed to fetch email logs");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchSmtpConfig = async () => {
//     try {
//       setLoading(true);
//       const response = await ApiServices.get(
//         `${BASE_URL}/clients/${clientId}/email-config/`,
//         authHeaders
//       );
//       setSmtpConfig(response?.data || null);
//     } catch (error) {
//       if (error?.response?.status === 404) {
//         setSmtpConfig(null);
//         return;
//       }
//       handleApiError(error, "Failed to fetch email config");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!clientId || !token) return;
//     fetchTemplates();
//     fetchLogs();
//     fetchSmtpConfig();
//   }, [clientId, token]);

//   const openCreateTemplate = () => {
//     const form = defaultTemplateForm(clientId);
//     const html = buildBodyHtmlFromBlocks(form.body_json.blocks);
//     setTemplateForm({
//       ...form,
//       body_html: html,
//       variables: extractVariablesFromTemplate({ ...form, body_html: html }),
//     });
//     setSelectedTemplate(null);
//     setTemplateDialogOpen(true);
//   };

//   const openEditTemplate = (template) => {
//     const next = {
//       ...template,
//       body_json: template.body_json || { blocks: [] },
//       variables: template.variables || [],
//     };
//     setTemplateForm(next);
//     setSelectedTemplate(template);
//     setTemplateDialogOpen(true);
//   };

//   const saveTemplate = async () => {
//     if (!templateForm.name?.trim()) {
//       showSnackbar("Template name is required", "error");
//       return;
//     }
//     if (!templateForm.subject?.trim()) {
//       showSnackbar("Subject is required", "error");
//       return;
//     }
//     if (!templateForm?.body_json?.blocks?.length) {
//       showSnackbar("At least one email block is required", "error");
//       return;
//     }
//     if (!templateForm.is_global && !templateForm.client_id) {
//       showSnackbar("Client ID is required for private template", "error");
//       return;
//     }

//     const computedHtml = buildBodyHtmlFromBlocks(templateForm?.body_json?.blocks || []);
//     const payload = {
//       ...templateForm,
//       body_html: computedHtml,
//       variables: extractVariablesFromTemplate({
//         ...templateForm,
//         body_html: computedHtml,
//       }),
//     };

//     try {
//       setLoading(true);
//       if (payload.id) {
//         await ApiServices.put(
//           `${BASE_URL}/email-templates/${payload.id}/`,
//           payload,
//           authHeaders
//         );
//         showSnackbar("Template updated successfully", "success");
//       } else {
//         await ApiServices.post(`${BASE_URL}/email-templates/`, payload, authHeaders);
//         showSnackbar("Template created successfully", "success");
//       }

//       setTemplateDialogOpen(false);
//       fetchTemplates();
//     } catch (error) {
//       handleApiError(error, "Failed to save template");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const deleteTemplate = async (templateId) => {
//     try {
//       setLoading(true);
//       await ApiServices.delete(
//         `${BASE_URL}/email-templates/${templateId}/?client_id=${clientId}`,
//         authHeaders
//       );
//       showSnackbar("Template deleted successfully", "success");
//       fetchTemplates();
//     } catch (error) {
//       handleApiError(error, "Failed to delete template");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const sendEmail = async () => {
//     if (!sendForm.template_id) {
//       showSnackbar("Please select a template", "error");
//       return;
//     }
//     if (!sendForm.recipient_email?.trim()) {
//       showSnackbar("Recipient email is required", "error");
//       return;
//     }

//     let parsedVariables = {};
//     try {
//       parsedVariables = JSON.parse(sendForm.variablesText || "{}");
//     } catch (e) {
//       showSnackbar("Variables JSON is invalid", "error");
//       return;
//     }

//     const payload = {
//       client_id: clientId,
//       template_id: sendForm.template_id,
//       recipient_email: sendForm.recipient_email,
//       variables: parsedVariables,
//       campaign_id: sendForm.campaign_id || null,
//       unsubscribe_url: sendForm.unsubscribe_url || undefined,
//       reply_to: sendForm.reply_to || undefined,
//     };

//     try {
//       setLoading(true);
//       await ApiServices.post(`${BASE_URL}/email-templates/send/`, payload, authHeaders);
//       showSnackbar("Email sent successfully", "success");
//       setSendDialogOpen(false);
//       fetchLogs();
//     } catch (error) {
//       handleApiError(error, "Failed to send email");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const saveSmtpConfig = async () => {
//     if (!smtpForm.smtp_host?.trim()) {
//       showSnackbar("SMTP host is required", "error");
//       return;
//     }
//     if (!smtpForm.smtp_user?.trim()) {
//       showSnackbar("SMTP user is required", "error");
//       return;
//     }
//     if (!smtpForm.from_email?.trim()) {
//       showSnackbar("From email is required", "error");
//       return;
//     }
//     if (smtpForm.use_tls && smtpForm.use_ssl) {
//       showSnackbar("TLS and SSL cannot both be enabled", "error");
//       return;
//     }

//     try {
//       setLoading(true);

//       if (smtpConfig) {
//         const payload = { ...smtpForm };
//         if (!payload.smtp_password) delete payload.smtp_password;

//         await ApiServices.put(
//           `${BASE_URL}/clients/${clientId}/email-config/`,
//           payload,
//           authHeaders
//         );
//         showSnackbar("SMTP config updated successfully", "success");
//       } else {
//         if (!smtpForm.smtp_password?.trim()) {
//           showSnackbar("SMTP password is required while creating config", "error");
//           return;
//         }

//         await ApiServices.post(
//           `${BASE_URL}/clients/${clientId}/email-config/`,
//           smtpForm,
//           authHeaders
//         );
//         showSnackbar("SMTP config created successfully", "success");
//       }

//       setSmtpDialogOpen(false);
//       fetchSmtpConfig();
//     } catch (error) {
//       handleApiError(error, "Failed to save SMTP config");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const deleteSmtpConfig = async () => {
//     try {
//       setLoading(true);
//       await ApiServices.delete(
//         `${BASE_URL}/clients/${clientId}/email-config/`,
//         authHeaders
//       );
//       showSnackbar("SMTP config removed successfully", "success");
//       setSmtpConfig(null);
//       setSmtpDialogOpen(false);
//     } catch (error) {
//       handleApiError(error, "Failed to delete SMTP config");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ p: 2 }}>
//       <Card sx={{ borderRadius: 4 }}>
//         <CardContent sx={{ p: 3 }}>
//           <Stack
//             direction={{ xs: "column", md: "row" }}
//             justifyContent="space-between"
//             alignItems={{ xs: "flex-start", md: "center" }}
//             spacing={2}
//             sx={{ mb: 3 }}
//           >
//             <Box>
//               <Typography variant="h5" fontWeight={700}>
//                 Client Email Management
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Manage email templates, send emails, view logs and SMTP settings.
//               </Typography>
//             </Box>

//             <Stack direction="row" spacing={1} flexWrap="wrap">
//               <Button
//                 variant="outlined"
//                 startIcon={<RefreshOutlinedIcon />}
//                 onClick={() => {
//                   fetchTemplates();
//                   fetchLogs();
//                   fetchSmtpConfig();
//                 }}
//               >
//                 Refresh
//               </Button>
//               <Button
//                 variant="outlined"
//                 startIcon={<SettingsOutlinedIcon />}
//                 onClick={() => setSmtpDialogOpen(true)}
//               >
//                 SMTP Config
//               </Button>
//               <Button
//                 variant="contained"
//                 startIcon={<SendOutlinedIcon />}
//                 onClick={() => setSendDialogOpen(true)}
//               >
//                 Send Email
//               </Button>
//               <Button
//                 variant="contained"
//                 startIcon={<AddCircleOutlineIcon />}
//                 onClick={openCreateTemplate}
//               >
//                 New Template
//               </Button>
//             </Stack>
//           </Stack>

//           <Tabs value={tab} onChange={(_, value) => setTab(value)} sx={{ mb: 3 }}>
//             <Tab label="Templates" />
//             <Tab label="Logs" />
//             <Tab label="SMTP" />
//           </Tabs>

//           {loading && (
//             <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
//               <CircularProgress size={18} />
//               <Typography variant="body2">Loading...</Typography>
//             </Stack>
//           )}

//           {tab === 0 && (
//             <EmailTemplatesTab
//               templates={templates}
//               templateFilter={templateFilter}
//               setTemplateFilter={setTemplateFilter}
//               onEdit={openEditTemplate}
//               onDelete={deleteTemplate}
//               onSend={(template) => {
//                 setSendForm((prev) => ({ ...prev, template_id: template.id }));
//                 setSendDialogOpen(true);
//               }}
//             />
//           )}

//           {tab === 1 && <EmailLogsTab logs={logs} />}

//           {tab === 2 && (
//             <EmailSmtpTab
//               smtpConfig={smtpConfig}
//               onEdit={() => setSmtpDialogOpen(true)}
//             />
//           )}
//         </CardContent>
//       </Card>

//       <EmailTemplateDialog
//         open={templateDialogOpen}
//         onClose={() => setTemplateDialogOpen(false)}
//         templateForm={templateForm}
//         setTemplateForm={setTemplateForm}
//         clientId={clientId}
//         onSave={saveTemplate}
//       />

//       <SendEmailDialog
//         open={sendDialogOpen}
//         onClose={() => setSendDialogOpen(false)}
//         templates={templates}
//         sendForm={sendForm}
//         setSendForm={setSendForm}
//         onSend={sendEmail}
//       />

//       <EmailSmtpTab.DialogComponent
//         open={smtpDialogOpen}
//         onClose={() => setSmtpDialogOpen(false)}
//         smtpConfig={smtpConfig}
//         smtpForm={smtpForm}
//         setSmtpForm={setSmtpForm}
//         onSave={saveSmtpConfig}
//         onDelete={deleteSmtpConfig}
//       />

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3500}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//       >
//         <Alert
//           severity={snackbar.severity}
//           variant="filled"
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default ClientEmailManager;


import React, { useEffect, useMemo, useState } from "react";
import {
  Box, Card, CardContent, Stack, Typography, Button, Tabs, Tab,
  Snackbar, Alert, CircularProgress, Chip, Paper, Fade
} from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";

import ApiServices from "../../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken } from "../../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

import EmailTemplatesTab from "./components/EmailTemplatesTab";
import EmailLogsTab from "./components/EmailLogsTab";
import EmailSmtpTab from "./components/EmailSmtpTab";
import EmailTemplateDialog from "./components/EmailTemplateDialog";
import SendEmailDialog from "./components/SendEmailDialog";

const BASE_URL = "/api/v1";
const accent = "#0d47a1";
const accentLight = "#e3f2fd";

export const TEMPLATE_TYPES = [
  "DISCOUNT_CAMPAIGN", "ANNOUNCEMENT", "FESTIVAL_OFFER",
  "LOYALTY_REWARD", "ORDER_CONFIRMATION", "REENGAGEMENT", "CUSTOM",
];
export const TEMPLATE_STATUS = ["draft", "active", "archived"];

export const defaultTemplateForm = (clientId) => ({
  id: null, name: "", template_type: "CUSTOM", is_global: false,
  client_id: clientId || "", subject: "", preview_text: "",
  body_json: {
    blocks: [
      { type: "header", content: "Your Email Title" },
      { type: "text", content: "Hi {{name}}, your message goes here." },
      { type: "button", label: "Call To Action", url: "{{action_url}}" },
      { type: "footer", content: "Rite Clinic" },
      { type: "unsubscribe", text: "Unsubscribe" },
    ],
  },
  body_html: "", variables: [], thumbnail_url: "", status: "draft",
});

export const defaultSendForm = {
  template_id: "", recipient_email: "",
  variablesText: '{\n  "name": "Priya",\n  "action_url": "https://example.com"\n}',
  campaign_id: "", unsubscribe_url: "", reply_to: "",
};

export const defaultSmtpForm = {
  smtp_host: "", smtp_port: 587, smtp_user: "", smtp_password: "",
  use_tls: true, use_ssl: false, from_email: "", is_active: true,
};

export const extractVariablesFromTemplate = (form) => {
  const found = new Set();
  const scan = (value) => {
    if (!value || typeof value !== "string") return;
    (value.match(/\{\{(.*?)\}\}/g) || []).forEach((m) => {
      const cleaned = m.replaceAll("{", "").replaceAll("}", "").trim();
      if (cleaned) found.add(cleaned);
    });
  };
  scan(form.subject);
  scan(form.preview_text);
  scan(form.body_html);
  (form?.body_json?.blocks || []).forEach((block) => {
    Object.values(block || {}).forEach((val) => {
      if (typeof val === "string") scan(val);
    });
  });
  return Array.from(found);
};

export const buildBodyHtmlFromBlocks = (blocks = []) => {
  const htmlParts = blocks.map((block) => {
    switch (block.type) {
      case "header": return `<h1 style="color:${accent};font-size:24px;margin-bottom:16px">${block.content || ""}</h1>`;
      case "text": return `<p style="font-size:15px;line-height:1.6;color:#333">${block.content || ""}</p>`;
      case "image": return block.url ? `<img src="${block.url}" alt="${block.alt || ""}" style="max-width:100%;border-radius:8px;margin:12px 0" />` : "";
      case "button": return `<div style="margin:20px 0"><a href="${block.url || "#"}" style="background:${accent};color:#fff;padding:12px 28px;border-radius:8px;text-decoration:none;font-weight:600">${block.label || "Click"}</a></div>`;
      case "footer": return `<p style="font-size:12px;color:#999;border-top:1px solid #eee;padding-top:12px;margin-top:24px">${block.content || ""}</p>`;
      case "unsubscribe": return `<p style="font-size:12px;text-align:center"><a href="#" style="color:${accent}">${block.text || "Unsubscribe"}</a></p>`;
      default: return "";
    }
  });
  return `<div style="max-width:600px;margin:0 auto;font-family:Arial,sans-serif;padding:24px">${htmlParts.join("")}</div>`;
};

const ClientEmailManager = () => {
  const clientId = sessionStorage.getItem("activeClientId");
  const token = getDecryptedAccessToken();

  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [logs, setLogs] = useState([]);
  const [smtpConfig, setSmtpConfig] = useState(null);
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [sendDialogOpen, setSendDialogOpen] = useState(false);
  const [smtpDialogOpen, setSmtpDialogOpen] = useState(false);
  const [templateForm, setTemplateForm] = useState(defaultTemplateForm(clientId));
  const [sendForm, setSendForm] = useState(defaultSendForm);
  const [smtpForm, setSmtpForm] = useState(defaultSmtpForm);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templateFilter, setTemplateFilter] = useState({ search: "", type: "", status: "" });
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const authHeaders = useMemo(() => ({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  }), [token]);

  const showSnackbar = (message, severity = "success") => setSnackbar({ open: true, message, severity });

  const handleApiError = (error, fallback = "Something went wrong") => {
    const msg = error?.response?.data?.detail || error?.response?.data?.non_field_errors?.[0] || error?.response?.data?.message || fallback;
    if (error?.response?.status === 423) { showSnackbar(msg || "Email module not enabled.", "warning"); return; }
    showSnackbar(msg, "error");
  };

  const fetchTemplates = async () => {
    if (!clientId) { showSnackbar("Client ID not found.", "error"); return; }
    try { setLoading(true); const r = await ApiServices.get(`${BASE_URL}/email-templates/?client_id=${clientId}`, authHeaders); setTemplates(Array.isArray(r?.data) ? r.data : []); }
    catch (e) { handleApiError(e, "Failed to fetch templates"); } finally { setLoading(false); }
  };

  const fetchLogs = async () => {
    try { setLoading(true); const r = await ApiServices.get(`${BASE_URL}/email-templates/logs/?client_id=${clientId}`, authHeaders); setLogs(Array.isArray(r?.data) ? r.data : []); }
    catch (e) { handleApiError(e, "Failed to fetch logs"); } finally { setLoading(false); }
  };

  const fetchSmtpConfig = async () => {
    try { setLoading(true); const r = await ApiServices.get(`${BASE_URL}/clients/${clientId}/email-config/`, authHeaders); setSmtpConfig(r?.data || null); }
    catch (e) { if (e?.response?.status === 404) { setSmtpConfig(null); return; } handleApiError(e, "Failed to fetch SMTP config"); }
    finally { setLoading(false); }
  };

  useEffect(() => { if (!clientId || !token) return; fetchTemplates(); fetchLogs(); fetchSmtpConfig(); }, [clientId, token]);

  const openCreateTemplate = () => {
    const form = defaultTemplateForm(clientId);
    const html = buildBodyHtmlFromBlocks(form.body_json.blocks);
    setTemplateForm({ ...form, body_html: html, variables: extractVariablesFromTemplate({ ...form, body_html: html }) });
    setSelectedTemplate(null); setTemplateDialogOpen(true);
  };

  const openEditTemplate = (template) => {
    setTemplateForm({ ...template, body_json: template.body_json || { blocks: [] }, variables: template.variables || [] });
    setSelectedTemplate(template); setTemplateDialogOpen(true);
  };

  const saveTemplate = async () => {
    if (!templateForm.name?.trim()) { showSnackbar("Template name required", "error"); return; }
    if (!templateForm.subject?.trim()) { showSnackbar("Subject required", "error"); return; }
    if (!templateForm?.body_json?.blocks?.length) { showSnackbar("At least one block required", "error"); return; }
    if (!templateForm.is_global && !templateForm.client_id) { showSnackbar("Client ID required", "error"); return; }
    const computedHtml = buildBodyHtmlFromBlocks(templateForm?.body_json?.blocks || []);
    const payload = { ...templateForm, body_html: computedHtml, variables: extractVariablesFromTemplate({ ...templateForm, body_html: computedHtml }) };
    try { setLoading(true);
      if (payload.id) { await ApiServices.put(`${BASE_URL}/email-templates/${payload.id}/`, payload, authHeaders); showSnackbar("Template updated"); }
      else { await ApiServices.post(`${BASE_URL}/email-templates/`, payload, authHeaders); showSnackbar("Template created"); }
      setTemplateDialogOpen(false); fetchTemplates();
    } catch (e) { handleApiError(e, "Failed to save template"); } finally { setLoading(false); }
  };

  const deleteTemplate = async (templateId) => {
    try { setLoading(true); await ApiServices.delete(`${BASE_URL}/email-templates/${templateId}/?client_id=${clientId}`, authHeaders); showSnackbar("Template deleted"); fetchTemplates(); }
    catch (e) { handleApiError(e, "Failed to delete"); } finally { setLoading(false); }
  };

  const sendEmail = async () => {
    if (!sendForm.template_id) { showSnackbar("Select a template", "error"); return; }
    if (!sendForm.recipient_email?.trim()) { showSnackbar("Recipient required", "error"); return; }
    let parsedVariables = {};
    try { parsedVariables = JSON.parse(sendForm.variablesText || "{}"); } catch { showSnackbar("Invalid JSON", "error"); return; }
    const payload = { client_id: clientId, template_id: sendForm.template_id, recipient_email: sendForm.recipient_email, variables: parsedVariables, campaign_id: sendForm.campaign_id || null, unsubscribe_url: sendForm.unsubscribe_url || undefined, reply_to: sendForm.reply_to || undefined };
    try { setLoading(true); await ApiServices.post(`${BASE_URL}/email-templates/send/`, payload, authHeaders); showSnackbar("Email sent!"); setSendDialogOpen(false); fetchLogs(); }
    catch (e) { handleApiError(e, "Failed to send"); } finally { setLoading(false); }
  };

  const saveSmtpConfig = async () => {
    if (!smtpForm.smtp_host?.trim()) { showSnackbar("SMTP host required", "error"); return; }
    if (!smtpForm.smtp_user?.trim()) { showSnackbar("SMTP user required", "error"); return; }
    if (!smtpForm.from_email?.trim()) { showSnackbar("From email required", "error"); return; }
    if (smtpForm.use_tls && smtpForm.use_ssl) { showSnackbar("TLS and SSL can't both be on", "error"); return; }
    try { setLoading(true);
      if (smtpConfig) { const p = { ...smtpForm }; if (!p.smtp_password) delete p.smtp_password; await ApiServices.put(`${BASE_URL}/clients/${clientId}/email-config/`, p, authHeaders); showSnackbar("SMTP updated"); }
      else { if (!smtpForm.smtp_password?.trim()) { showSnackbar("SMTP password required", "error"); return; } await ApiServices.post(`${BASE_URL}/clients/${clientId}/email-config/`, smtpForm, authHeaders); showSnackbar("SMTP created"); }
      setSmtpDialogOpen(false); fetchSmtpConfig();
    } catch (e) { handleApiError(e, "Failed to save SMTP"); } finally { setLoading(false); }
  };

  const deleteSmtpConfig = async () => {
    try { setLoading(true); await ApiServices.delete(`${BASE_URL}/clients/${clientId}/email-config/`, authHeaders); showSnackbar("SMTP removed"); setSmtpConfig(null); setSmtpDialogOpen(false); }
    catch (e) { handleApiError(e, "Failed to delete SMTP"); } finally { setLoading(false); }
  };

  const tabItems = [
    { label: "Templates", icon: <DescriptionOutlinedIcon /> },
    { label: "Email Logs", icon: <HistoryOutlinedIcon /> },
    { label: "SMTP Config", icon: <DnsOutlinedIcon /> },
  ];

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f8faff" }}>
      <Box sx={{ mx: "auto", px: { xs: 2, sm: 3 }, py: 3 }}>

        {/* Header */}
        <Paper elevation={0} sx={{ p: { xs: 2.5, sm: 3.5 }, mb: 3, borderRadius: 3, background: `linear-gradient(135deg, ${accent} 0%, #1565c0 100%)`, color: "#fff", border: "none" }}>
          <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems={{ md: "center" }} spacing={2}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Box sx={{ width: 52, height: 52, borderRadius: 3, backgroundColor: "rgba(255,255,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <EmailOutlinedIcon sx={{ fontSize: 28, color: "#fff" }} />
              </Box>
              <Box>
                <Typography variant="h5" fontWeight={700}>Email Management</Typography>
                <Typography variant="body2" sx={{ opacity: 0.85 }}>Create templates, send campaigns & manage SMTP</Typography>
              </Box>
            </Stack>
            <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
              <Button variant="outlined" startIcon={<RefreshOutlinedIcon />} onClick={() => { fetchTemplates(); fetchLogs(); fetchSmtpConfig(); }}
                sx={{ borderColor: "rgba(255,255,255,0.4)", color: "#fff", "&:hover": { borderColor: "#fff", backgroundColor: "rgba(255,255,255,0.1)" } }}>
                Refresh
              </Button>
              <Button variant="outlined" startIcon={<SettingsOutlinedIcon />} onClick={() => { if (smtpConfig) setSmtpForm({ ...smtpConfig, smtp_password: "" }); else setSmtpForm(defaultSmtpForm); setSmtpDialogOpen(true); }}
                sx={{ borderColor: "rgba(255,255,255,0.4)", color: "#fff", "&:hover": { borderColor: "#fff", backgroundColor: "rgba(255,255,255,0.1)" } }}>
                SMTP
              </Button>
              <Button variant="contained" startIcon={<SendOutlinedIcon />} onClick={() => setSendDialogOpen(true)}
                sx={{ backgroundColor: "#fff", color: accent, fontWeight: 600, "&:hover": { backgroundColor: "#e3f2fd" } }}>
                Send Email
              </Button>
              <Button variant="contained" startIcon={<AddCircleOutlineIcon />} onClick={openCreateTemplate}
                sx={{ backgroundColor: "rgba(255,255,255,0.2)", color: "#fff", fontWeight: 600, "&:hover": { backgroundColor: "rgba(255,255,255,0.3)" } }}>
                New Template
              </Button>
            </Stack>
          </Stack>

          {/* Stats */}
          <Stack direction="row" spacing={2} sx={{ mt: 2.5, flexWrap: "wrap" }} useFlexGap>
            {[
              { label: "Templates", value: templates.length },
              { label: "Active", value: templates.filter(t => t.status === "active").length },
              { label: "Emails Sent", value: logs.length },
              { label: "SMTP", value: smtpConfig ? "Configured" : "Not Set" },
            ].map((stat) => (
              <Chip key={stat.label} label={`${stat.label}: ${stat.value}`}
                sx={{ backgroundColor: "rgba(255,255,255,0.15)", color: "#fff", fontWeight: 600, fontSize: 13, height: 32 }} />
            ))}
          </Stack>
        </Paper>

        {/* Tabs */}
        <Paper elevation={0} sx={{ borderRadius: 3, border: "1px solid #e3e8f0", overflow: "hidden" }}>
          <Tabs value={tab} onChange={(_, v) => setTab(v)}
            sx={{
              px: 2, pt: 1, "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontSize: 14, minHeight: 48, color: "#666" },
              "& .Mui-selected": { color: `${accent} !important` },
              "& .MuiTabs-indicator": { backgroundColor: accent, height: 3, borderRadius: "3px 3px 0 0" },
            }}>
            {tabItems.map((t, i) => <Tab key={i} label={t.label} icon={t.icon} iconPosition="start" />)}
          </Tabs>

          <Box sx={{ p: { xs: 2, sm: 3 } }}>
            {loading && (
              <Fade in><Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2, p: 1.5, borderRadius: 2, backgroundColor: accentLight }}>
                <CircularProgress size={20} sx={{ color: accent }} />
                <Typography variant="body2" sx={{ color: accent, fontWeight: 500 }}>Loading...</Typography>
              </Stack></Fade>
            )}

            {tab === 0 && (
              <EmailTemplatesTab templates={templates} templateFilter={templateFilter} setTemplateFilter={setTemplateFilter}
                onEdit={openEditTemplate} onDelete={deleteTemplate}
                onSend={(template) => { setSendForm((prev) => ({ ...prev, template_id: template.id })); setSendDialogOpen(true); }} />
            )}
            {tab === 1 && <EmailLogsTab logs={logs} />}
            {tab === 2 && <EmailSmtpTab smtpConfig={smtpConfig} onEdit={() => { if (smtpConfig) setSmtpForm({ ...smtpConfig, smtp_password: "" }); else setSmtpForm(defaultSmtpForm); setSmtpDialogOpen(true); }} />}
          </Box>
        </Paper>
      </Box>

      <EmailTemplateDialog open={templateDialogOpen} onClose={() => setTemplateDialogOpen(false)}
        templateForm={templateForm} setTemplateForm={setTemplateForm} clientId={clientId} onSave={saveTemplate} />

      <SendEmailDialog open={sendDialogOpen} onClose={() => setSendDialogOpen(false)}
        templates={templates} sendForm={sendForm} setSendForm={setSendForm} onSend={sendEmail} />

      <EmailSmtpTab.DialogComponent open={smtpDialogOpen} onClose={() => setSmtpDialogOpen(false)}
        smtpConfig={smtpConfig} smtpForm={smtpForm} setSmtpForm={setSmtpForm} onSave={saveSmtpConfig} onDelete={deleteSmtpConfig} />

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar((p) => ({ ...p, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <Alert severity={snackbar.severity} onClose={() => setSnackbar((p) => ({ ...p, open: false }))} sx={{ borderRadius: 2, fontWeight: 500 }}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default ClientEmailManager;
